export interface paymentIntent {
  data: {
    id: string;
    amount: string;
    type: number;
    lastfourdigit: number;
    bin: string;
    network: string;
    status: string;
    operation_type: string;
    operation_number: number;
    updated_at: number;
  }
}

export type GraphPaymentIntentResult = {
  paymentIntentDetail: GraphPaymentIntent
}

export enum InstallmentTypeEnum {
	NO_INSTALLMENT = "NO_INSTALLMENT",
	ISSUER_INSTALLMENT = "ISSUER_INSTALLMENT",
	MERCHANT_INSTALLMENT = "MERCHANT_INSTALLMENT"
}

export type GraphPaymentIntent = {
  amount: number;
  authorization_code: string;
  bin: string;
  bsk_device_alias: string;
  
  channel: string;
  created_at: string;
  created_at_time_zone: string;
  currency: string;
  deposit_amount?: number;
  deposit_date?: string;
  description: string;
  expired_at?: string;
  final_amount?: number;
  geolocation: string;
  has_reversal: boolean;
  id: string;
  installment_count: number;
  lastfourdigit: string;
  merchant_id: string;
  merchant_name: string;
  metadata: string;
  mode?: string;
  network: string;
  onlinecheckout_id?: string;
  operation_number: string;
  operation_type: string;
  order_number: string;
  paymentintent_parent_id?: string;
  refunded_amount: number;
  serial_number: string;
  software_version: string;
  source: string;
  status: string;
  status_code: string;
  status_code_description: string;
  terminal_type: string;
  terminalcheckout_id?: string;
  threeds_acceptRisk?: string;
  threeds_eci?: string;
  threeds_specificationVersion?: string;
  total_commissions?: number;
  total_taxes?: number;
  type: string;
  updated_at: string;
  updated_at_time_zone: string;

  current_installment_number: number;
  card_installment_type: InstallmentTypeEnum;
  payment_method_option_card_installment_amount: number;
}

export type GraphPaymentIntentTransformed = GraphPaymentIntent & {
  masked_card_number: string;
}